export default function ProgressBar({ percent = 0, state = 'normal' }) {
  const clamped = Math.max(0, Math.min(100, percent))

  const color = {
    normal: 'var(--dash-primary)',
    warning: 'var(--dash-warning)',
    danger: 'var(--dash-danger)',
  }[state]

  return (
    <div
      className="h-1.5 w-full overflow-hidden rounded-full"
      style={{ background: 'var(--dash-surface-subtle)' }}
    >
      <div
        className="h-full rounded-full transition-[width] duration-500 ease-out"
        style={{ width: `${clamped}%`, background: color }}
      />
    </div>
  )
}
